import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.scss';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navRef = useRef(null);
  const menuToggleRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Close menu when clicking on a nav link (only on mobile/iPad)
  const handleNavLinkClick = () => {
    // Check if menu-toggle is visible (mobile/iPad view)
    if (menuToggleRef.current && window.getComputedStyle(menuToggleRef.current).display !== 'none') {
      closeMenu();
    }
  };

  // Close menu when clicking outside (only on mobile/iPad)
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if menu-toggle is visible (mobile/iPad view)
      if (menuToggleRef.current && window.getComputedStyle(menuToggleRef.current).display !== 'none') {
        if (
          navRef.current &&
          menuToggleRef.current &&
          !navRef.current.contains(event.target) &&
          !menuToggleRef.current.contains(event.target) &&
          isMenuOpen
        ) {
          closeMenu();
        }
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isMenuOpen]);

  // Close menu when route changes (only on mobile/iPad)
  useEffect(() => {
    if (menuToggleRef.current && window.getComputedStyle(menuToggleRef.current).display !== 'none') {
      closeMenu();
    }
  }, [location.pathname]);

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Left Section - Title and Navigation */}
          <div className="header-left">
            {/* Main Title */}
            <Link to="/" className="main-title">
              Africa Energy Access Trends
            </Link>
            
            {/* Navigation */}
            <nav ref={navRef} className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
              <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`} onClick={handleNavLinkClick}>Home</Link>
              <Link to="/country-energy-profile" className={`nav-link ${isActive('/country-energy-profile') ? 'active' : ''}`} onClick={handleNavLinkClick}>Country Energy Profile</Link>
              <Link to="/impact-insights" className={`nav-link ${isActive('/impact-insights') ? 'active' : ''}`} onClick={handleNavLinkClick}>Impact Insights</Link>
              <Link to="/projects" className={`nav-link ${isActive('/projects') ? 'active' : ''}`} onClick={handleNavLinkClick}>Projects</Link>
              <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`} onClick={handleNavLinkClick}>About</Link>
              {/* <Link to="/methodology" className={`nav-link ${isActive('/methodology') ? 'active' : ''}`} onClick={handleNavLinkClick}>Methodology</Link> */}
            </nav>
          </div>

          {/* Right Section - Partner Logos */}
          <div className="header-right">
            <div className="partner-logos">
              <div className="partner-logo">
                <a href="https://vasudhausa.org/" target="_blank">
                  <img src="/images/navbar-logo/vasudha-usa-logo.png" alt="Vasudha Foundation USA logo" className="partner-logo-img" />
                </a>
              </div>
              <div className="partner-logo">
                <a href="https://access-coalition.org/" target="_blank">
                <img src="/images/navbar-logo/access-coalition.png" alt="ACCESS Coalition logo" className="partner-logo-img" />
                </a>
              </div>
              <div className="partner-logo">
                <a href="https://www.lboro.ac.uk/research/steer/" target="_blank">
                <img src="/images/navbar-logo/steer-logo.jpg" alt="STEER energy logo" className="partner-logo-img" />
                </a>
              </div>
            </div>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            ref={menuToggleRef}
            className={`menu-toggle ${isMenuOpen ? 'menu-open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;